/* eslint-disable @typescript-eslint/no-unused-vars */
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import { type ChildDuplicate } from 'slices/duplicateChildSlice'

export function DuplicateBreakdown (props: { dupeData: ChildDuplicate, warningTreshold: number, acceptanceTreshold: number }): JSX.Element {
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  const matchValue = props.dupeData.matchedValues?.reduce((accumulator, matchValue) => accumulator + Number((matchValue.points ?? 0)), 0) ?? 0
  let result = ''

  if (matchValue === 100) {
    result = 'Extremely Likely (100 Points)'
  } else if (matchValue >= props.acceptanceTreshold) {
    result = `Very Likely (>= ${props.acceptanceTreshold} Points)`
  } else if (matchValue >= props.warningTreshold) {
    result = `Moderately Likely (>= ${props.warningTreshold} Points)`
  }

  return <Box sx={{ display: 'block', marginLeft: '18px', heigjustifyContent: 'center', alignItems: 'left' }}>
    {props.dupeData.matchedValues?.map(v => {
      return <Typography sx={{ display: 'flex', flexDirection: 'row' }} variant='body1'>
        {v.type} {v.strength} Match: {v.points} Points
      </Typography>
    })}
    <Typography sx={{ display: 'flex', flexDirection: 'row' }} variant='body1'>
      <>Total Score : <Typography fontWeight={'bold'} sx={{ pl: '10px' }}>{matchValue} Points</Typography></>
    </Typography>
    <Typography sx={{ fontWeight: 'bold', display: 'flex', flexDirection: 'row' }} variant='body1'>
      {result}
    </Typography>

  </Box>
}
